import React, { useState, useEffect } from 'react';
import { db } from './firebase';

function LikeButton({ docId, count }) {
  useEffect(() => {}, []);

  const handleClick = (Id) => {
    const counts = db
      .collection('posts')
      .doc(Id)
      .update({
        count: count + 1,
      });
  };
  return (
    <div style={{ textAlign: 'right', width: '100%' }}>
      <div>
        <button
          style={{
            border: 'none',
            background: 'transparent',
            outline: 'none',
          }}
          className='link-btn'
          onClick={() => handleClick(docId)}>
          💗 Likes: {count}
        </button>
      </div>
    </div>
  );
}

export default LikeButton;
